/* @flow */
// typecheck: ignore file
import React from 'react';
import AuthActions from 'auth/AuthActions';
import TreasurerAddBankAccount from 'payments/components/TreasurerAddBankAccount.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import TreasurerAddBankAccountInterstitial from 'payments/components/TreasurerAddBankAccountInterstitial.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import type { ConnectedBankAccountRequest } from 'reducers/connectedBankAccountRequest';
import { load } from 'reducers/connectedBankAccountRequest';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';

type Props = {
  token: string,
  load: (token: string) => any,
  connectedBankAccountRequest?: ConnectedBankAccountRequest,
};

type State = {
  interstitial: boolean,
};

class TreasurerAddBankAccountPage extends React.Component {
  props: Props;

  state: State = {
    interstitial: true,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    location: React.PropTypes.object.isRequired,
  };

  componentWillMount() {
    const onAuthenticated = () => this.props.load(this.props.token);
    const onUnauthenticated = () => {
      this.context.router.push({
        pathname: '/activities/treasurer/sign_up',
        query: this.context.location.query,
      });
    };

    AuthActions.checkLoggedIn().then(onAuthenticated, onUnauthenticated);
  }

  onBankAccountAdded = () => {
    this.context.router.push('/settings/transactions');
  }

  closeInterstitial = () => {
    this.setState({ interstitial: false });
  }

  render() {
    if (!this.props.connectedBankAccountRequest) {
      return null;
    }

    const {
      error,
      isLoading,
      connectedBankAccount,
    } = this.props.connectedBankAccountRequest;

    if (isLoading) {
      return <CenteredLoadingIndicator />;
    }

    if (error) {
      return (
        <CenteredContainer>
          <div style={{ textAlign: 'center' }}>
            <div>
              <Text size="large">
                An error happened, the link might have expired.
              </Text>
            </div>
            <div style={{ marginTop: 10 }}>
              <Text color="lava">
                Error: {error}
              </Text>
            </div>
            <Button to="/settings/transactions" size="xsmall" style={{ marginTop: 15 }}>
              Go to my account
            </Button>
          </div>
        </CenteredContainer>
      );
    }

    if (this.state.interstitial) {
      return (
        <TreasurerAddBankAccountInterstitial
          connectedBankAccount={connectedBankAccount}
          onAddBankAccount={this.closeInterstitial}
        />
      );
    }

    return (
      <TreasurerAddBankAccount
        connectedBankAccount={connectedBankAccount}
        onBankAccountAdded={this.onBankAccountAdded}
      />
    );
  }
}

function mapStateToProps(state: Object, props: Props) {
  return {
    connectedBankAccountRequest: state.connectedBankAccountRequest.get(props.token),
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowIssue
  return bindActionCreators({ load }, dispatch);
}

export { TreasurerAddBankAccountPage };
export default connect(mapStateToProps, mapDispatchToProps)(TreasurerAddBankAccountPage);



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerAddBankAccountPage.jsx